import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=a4cc1df6&scoped=true"
import script from "./PluginList.vue?vue&type=script&lang=js"
export * from "./PluginList.vue?vue&type=script&lang=js"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=a4cc1df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cc1df6",
  null
  
)

export default component.exports